export var AppendToBodyPositionTypeEnum;
(function (AppendToBodyPositionTypeEnum) {
    AppendToBodyPositionTypeEnum["BOTTOM_LEFT"] = "BottomLeft";
    AppendToBodyPositionTypeEnum["TOP_RIGHT"] = "TopRight";
})(AppendToBodyPositionTypeEnum || (AppendToBodyPositionTypeEnum = {}));
